import React from 'react'
import { NestedDict } from 'app/types'
import { AnalyticsBarChart } from 'views/AdminPage/Analytics/AnalyticsBarChart'

interface EmailAnalyticsTileProps {
    data: NestedDict[],
}

export function EmailAnalyticsTile(props: EmailAnalyticsTileProps) {
    const { data } = props

    return <div className="analytics-tile">
        <AnalyticsBarChart title="Emails Sent" data={data} dateKey="dateSent" dataKey="Emails" color="var(--tertiary-mid)"/>
    </div>
}
